import {
  TableRow,
  TableCell,
  withStyles,
  Typography,
  TableHead,
  TableSortLabel,
  TableContainer,
} from "@material-ui/core";

import { COLORS } from "../../theme/colors";

export const StyledTableCell = withStyles((theme) => ({
  root: {
    padding: `${theme.spacing(2.25)}px ${theme.spacing(3)}px`,
    border: "none",
  },
}))(TableCell);

export const BorderTableCell = withStyles((theme) => ({
  root: {
    padding: `${theme.spacing(2.25)}px ${theme.spacing(3)}px`,
    borderRight: "none",
  },
}))(TableCell);

export const StyledTableRow = withStyles(() => ({
  root: {
    "&:not(:last-child)": {
      borderBottom: `1px solid ${COLORS.darks[0][10]}`,
    },
  },
}))(TableRow);

export const StyledTableContainer = withStyles(() => ({
  root: {
    borderRadius: 8,
    maxHeight: 556,
    "& > table": {
      borderCollapse: "separate",
    },
  },
}))(TableContainer);

export const EnhancedTableHead = ({ headCells, classes, order, orderBy, onRequestSort }) => {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const getCellClassName = (headCell) => {
    switch (headCell.label) {
      case "Location":
        return classes.locationCell;
      case "Recent Activity":
        return classes.activityCell;
      default:
        return;
    }
  };

  return (
    <TableHead>
      <StyledTableRow>
        {headCells.map((headCell) =>
          headCell.id ? (
            <StyledTableCell
              key={headCell.id}
              sortDirection={orderBy === headCell.id ? order : false}
              className={getCellClassName(headCell)}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                <Typography variant="subtitle2" className={classes.bold} noWrap>
                  {headCell.label}
                </Typography>
              </TableSortLabel>
            </StyledTableCell>
          ) : (
            <StyledTableCell className={classes.activityCell} key={headCell.label}>
              <Typography variant="subtitle2" className={classes.bold}>
                {headCell.label}
              </Typography>
            </StyledTableCell>
          )
        )}
      </StyledTableRow>
    </TableHead>
  );
};
